/**
 * Erzwingt die Position des Swym-Wunschzettel-Buttons oben rechts,
 * auch wenn Swym die Position per JS dynamisch neu berechnet
 * (z.B. beim Bildwechsel auf Produktkarten mit AI-Badge).
 * Ergaenzung zu assets/ai-generated-badge.css.
 *
 * Auf mobilen Produktkarten (.card__media, Breakpoint <= 749px) wird das
 * Icon zusaetzlich etwas hoeher gesetzt (0.4rem statt 0.8rem), passend zur
 * gleichzeitig auf 3.75rem (Breite des AI-Badge-Icons) vergroesserten
 * Breite in assets/ai-generated-badge.css. Desktop und Produktdetailseite
 * bleiben unveraendert.
 */
(function () {
  function fixSwymPosition(el) {
    var isMobileCard =
      window.matchMedia('(max-width: 749px)').matches &&
      !!el.closest('.card__media');
    el.style.setProperty('top', isMobileCard ? '0.4rem' : '0.8rem', 'important');
    el.style.setProperty('right', '0.8rem', 'important');
    el.style.setProperty('left', 'auto', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
  }

  function fixAll() {
    document
      .querySelectorAll('.swym-advanced-wishlist-collections-container')
      .forEach(fixSwymPosition);
  }

  // Initial beim Laden korrigieren
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAll);
  } else {
    fixAll();
  }

  // Laufend korrigieren, wenn Swym die Buttons neu einfuegt oder deren
  // style/inline-Attribute nach einem Bildwechsel neu setzt
  var observer = new MutationObserver(function (mutations) {
    var needsFix = false;
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        if (
          mutation.target.classList &&
          mutation.target.classList.contains('swym-advanced-wishlist-collections-container')
        ) {
          needsFix = true;
        }
      }
      if (mutation.type === 'childList') {
        needsFix = true;
      }
    });
    if (needsFix) {
      fixAll();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style'],
  });

  // Bei Resize (z.B. Rotation oder Fenstergroessenaenderung ueber den
  // Breakpoint hinweg) Position neu berechnen.
  window.addEventListener('resize', fixAll);
})();
